import router from '../router/index'
import store from "../store/store";

import { axios, BaseApiUrl } from './axios_config';


export function getProductSKUList(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/GetProductSKUList`, params);
}


export function getCustomerList(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/GetCustomerList`, params);
}

export function GetCurrencyList(params) {
   return axios.post(`${BaseApiUrl}/Util/GetCurrencyServiceModelList`, params);
}



export function AddProductSKU(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/AddProductSKU`, params);
}

export function EditProductSKU(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/EditProductSKU`, params);
}

export function DeleteProductSKU(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/DeleteProductSKU`, params);
}

export function AuditProductSKU(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/AuditProductSKU`, params);
}


export function SetProductSKUAlias(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/SetProductSKUAlias`, params);
}


export function GetProductSKUAliasList(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/GetProductSKUAliasList`, params);
}


export function GetProductSkuAttachList(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/GetProductSkuAttachList`, params);
}

//文件导入URL
export const ImportProductSKUAttachFile=`${BaseApiUrl}/ProductSKU/ImportProductSKUAttachFile`;

export function DeleteProductSKUAttach(params) {
   return axios.post(`${BaseApiUrl}/ProductSKU/DeleteProductSKUAttach`, params);
}



//导出
export function DownloadProductSKUAttach(url,filename) {

   var params = {filePath:url};

   return axios({
       url: `${BaseApiUrl}/file/ftp/down`,
       method: "get",
       params: params,
       responseType: 'blob',
   })
       .then((res) => {
           var content = res.data;
           console.log(res)
           var blob = new Blob([content]);
           console.log(blob)
           let fileName = filename;
           let blobObject = new Blob([content]);
           //是IE浏览器
           if (!!window.ActiveXObject || "ActiveXObject" in window) {
               window.navigator.msSaveOrOpenBlob(blobObject, fileName);
           } else {//火狐谷歌都兼容
               //模板中要有一个预定义好的a标签
               var elink = document.createElement("a");
               elink.download = fileName;
               elink.style.display = "none";
               elink.href = URL.createObjectURL(blobObject);
               elink.setAttribute('download', fileName)
               document.body.appendChild(elink);
               elink.click();
               URL.revokeObjectURL(elink.href); // 释放URL 对象
               document.body.removeChild(elink);
           }

       }).catch((err) => {
           console.error(err);

       });

};



